<template>
    <rkm-layout-body title="Reagendamento por médico">
        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/regulacao/reagendamento-medico/List'

export default {components: {List}}
</script>
